import React, { Component } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Navbar, NavbarBrand, Nav, NavbarToggler, Collapse, NavItem, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input } from 'reactstrap';
import { Button as TcButton } from './ui';
import { Link, NavLink } from 'react-router-dom';
import { SignIn } from '../redux/ActionCreators';

import { Control, LocalForm, Errors } from 'react-redux-form';
import { connect } from 'react-redux';
import { baseUrl, STUDENT_ID } from '../Shared/baseURL';
import { SUPPORT_EMAIL, SUPPORT_MAILTO } from '../Shared/contact';
import axios from 'axios';
import * as Sentry from '@sentry/react';
import '../Shared/HeaderComponent.css';

import { useNavigate } from 'react-router-dom';
import { getBillingPlan, getPlanDateLabel, resolvePlanId } from '../logic/planSelection';
import { syncCurrentUserProfileToStorage, getStoredSubscriptions, getStoredSubscriptionForCourse, setStoredSubscriptions } from '../logic/authStorage';
import { getActiveCourseId } from '../logic/courseContext';
import { parseJwtExpMs } from '../logic/sessionExpiry';
import { getRoleHomePath } from '../logic/homeRoute';
import TrialBanner from './TrialBanner';

const mapDispatchToProps = (dispatch) => ({

    SignIn: (formdata, callbackfunction) => { dispatch(SignIn(formdata, callbackfunction)) }

});



class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isNavOpen: false,
            isModalOpen: false,
            dropdownOpen: false,
            profileDropdownOpen: false,
            isChangePasswordModalOpen: false,
            isResetChildPasswordModalOpen: false,
            selectedStudentName: localStorage.getItem('selectedStudent_name') || "My Students",
            resendingVerify: false,
            resendMsg: '',
            userIsVerified: undefined,
            userRole: undefined,
            isSessionInfoOpen: false,
        };
        this.toggleNav = this.toggleNav.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.toggleProfileDropdown = this.toggleProfileDropdown.bind(this);
        this.toggleChangePasswordModal = this.toggleChangePasswordModal.bind(this);
        this.toggleResetChildPasswordModal = this.toggleResetChildPasswordModal.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.handleResetChildPassword = this.handleResetChildPassword.bind(this);
        this.handleCancelSubscription = this.handleCancelSubscription.bind(this);
        this.logout = this.logout.bind(this);
        this.resendVerification = this.resendVerification.bind(this);
    }

    fetchVerificationStatus = () => {
        //alert("fetchVerificationStatus called");
        const token = localStorage.getItem('studyapp.com');
        if (!token) {
            this.setState({ userIsVerified: undefined, userRole: undefined });
            return Promise.resolve();
        }
        return axios.get(`${baseUrl}users/me`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }

        })
            .then(resp => {
                const u = resp.data?.user || resp.data;
                //alert("u: " + JSON.stringify(u));
                if (u) {
                    this.setState({ userIsVerified: !!u.isVerified, userRole: u.role });
                    // Cache the latest server flags so verification and analytics
                    // behavior stays aligned after reloads or admin-side edits.
                    syncCurrentUserProfileToStorage(u);
                }
            })
            .catch(() => {/* ignore errors for banner */ });
    };
    toggleResetChildPasswordModal() {
        this.setState({ isResetChildPasswordModalOpen: !this.state.isResetChildPasswordModalOpen });
    }

    toggleSessionInfoModal = () => {
        this.setState({ isSessionInfoOpen: !this.state.isSessionInfoOpen });
    };

    // Handle the reset child password form submission
    handleResetChildPassword(event) {
        event.preventDefault();
        const newPassword = this.childNewPassword.value;

        axios.post(`${baseUrl}users/parent-reset-child-password`,
            { newPassword },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('studyapp.com')}`
                }
            }
        )
            .then(response => {
                alert("Child's password has been reset successfully.");
                this.toggleResetChildPasswordModal();
            })
            .catch(error => {
                if (error.response?.data?.errors) {
                    alert(error.response.data.errors.join('\n'));
                } else {
                    alert("Error resetting child's password: " + (error.response?.data?.error || error.message));
                }
            });
    }
    // NEW: Toggle the profile dropdown
    toggleProfileDropdown() {
        this.setState({ profileDropdownOpen: !this.state.profileDropdownOpen });
    }

    // NEW: Toggle the change password modal
    toggleChangePasswordModal() {
        this.setState({ isChangePasswordModalOpen: !this.state.isChangePasswordModalOpen });
    }

    // NEW: Handle the change password form submission
    handleChangePassword(event) {
        event.preventDefault();
        const oldPassword = this.oldPassword.value;
        const newPassword = this.newPassword.value;

        // Call the change password API endpoint (adjust the endpoint URL if needed)
        axios.post(`${baseUrl}users/changePassword`, { oldPassword, newPassword }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('studyapp.com')}`
            }
        })
            .then(response => {
                alert("Password changed successfully.");
                this.toggleChangePasswordModal();
            })
            .catch(error => {
                alert("Error changing password: " + error.message);
                Sentry.captureException(error);
            });
    }

    // Resend verification email for unverified parents
    resendVerification() {
        if (this.state.resendingVerify) return;
        this.setState({ resendingVerify: true, resendMsg: '' });
        axios.post(`${baseUrl}users/resend-verification`, {}, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('studyapp.com')}`
            }
        })
            .then(() => {
                this.setState({ resendMsg: 'Verification email sent. Please check your inbox (and spam).', resendingVerify: false });
            })
            .catch((error) => {
                const msg = error?.response?.data?.error || error?.response?.data?.message || 'Unable to send verification email.';
                this.setState({ resendMsg: msg, resendingVerify: false });
                Sentry.captureException(error);
            });
    }

    // ===== Session expiry countdown display =====
    // The actual timer/expiry-detection logic lives in SessionWatcher
    // (rendered once, route-independently, by HomeComponent) and the shared
    // sessionExpiry helper. Header just displays the remaining time it's
    // handed via props.sessionRemainingMs.
    formatDuration = (ms) => {
        if (ms == null) return '';
        if (ms <= 0) return 'Expired';
        const totalSeconds = Math.floor(ms / 1000);
        const days = Math.floor(totalSeconds / (24 * 3600));
        const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        const pad = (n) => String(n).padStart(2, '0');
        return `${days}d ${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`;
    };


    // NEW: Handle cancel subscription
    handleCancelSubscription() {
        const userId = this.props.user?.userID;
        if (!userId) return;

        if (!window.confirm('Are you sure you want to cancel your subscription?')) return;

        const activeCourseId = getActiveCourseId();

        axios.post(
            `${baseUrl}payments/cancel-subscription`,
            { courseId: activeCourseId },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('studyapp.com')}`
                }
            }
        )
            .then(response => {
                alert('Your subscription has been cancelled.');
                const updated = getStoredSubscriptions().map(s => {
                    if (s.courseId && s.courseId.toString() === String(activeCourseId)) {
                        return {
                            ...s,
                            status: response.data.subscription?.status || s.status,
                            endDate: response.data.subscription?.current_period_end || s.endDate,
                            cancelAtPeriodEnd: true,
                        };
                    }
                    return s;
                });
                setStoredSubscriptions(updated);
                this.forceUpdate();
            })
            .catch(error => {
                alert('Error cancelling subscription: ' + (error.response?.data?.message || error.message));
            });
    }


    toggleNav() {
        this.setState({
            isNavOpen: !this.state.isNavOpen
        });
    }

    toggleModal() {
        this.setState({
            isModalOpen: !this.state.isModalOpen
        });
    }

    // State-lifted: methods mycallback, fetchChildren, componentDidMount, validateToken, decodeJWT, handleLogin removed.
    logout() {
        this.props.onLogout();
    }

    // NEW: Method to handle student selection from the dropdown
    handleSelectStudent(child) {
        // Update localStorage with selected student's details
        localStorage.setItem('selectedStudentID', child._id);
        localStorage.setItem('selectedStudent_name', `${child.firstname} `);
        // Update state so that the dropdown toggle displays the selected name
        this.setState({ selectedStudentName: `${child.firstname} ` });
    }

    componentDidMount() {
        const { childrenList } = this.props;
        // If exactly one student exists, auto-select them (and persist)
        if (Array.isArray(childrenList) && childrenList.length === 1) {
            this.handleSelectStudent(childrenList[0]);
        }
        // If a student was previously selected, rehydrate the displayed name
        const savedName = localStorage.getItem('selectedStudent_name');
        if (savedName) {
            this.setState({ selectedStudentName: savedName });
        }
        // Fetch server truth for verification/banner on mount
        this.fetchVerificationStatus();
        //alert("this.props.user: " + JSON.stringify(this.props.user));
        // If we are on the session-expired page but now have a valid token, bounce back to intended page
        try {
            if (window.location.pathname === '/session-expired') {
                const tok = localStorage.getItem('studyapp.com');
                const expMs = parseJwtExpMs(tok);
                if (tok && expMs && expMs > Date.now()) {
                    const qs = new URLSearchParams(window.location.search);
                    const qpReturnTo = qs.get('returnTo');
                    const storedReturnTo = localStorage.getItem('returnTo');
                    const target = qpReturnTo || storedReturnTo || '/';
                    // clear guards
                    localStorage.removeItem('sessionExpiredNotified');
                    if (storedReturnTo) localStorage.removeItem('returnTo');
                    window.location.replace(target);
                }
            }
        } catch (_) { /* ignore */ }
    }

    componentDidUpdate(prevProps) {
        // If login state or user object changed, refresh verification status once
       // console.log("Header componentDidUpdate called");
        if (prevProps.isLoggedIn !== this.props.isLoggedIn || prevProps.user !== this.props.user) {
            console.log("Header detected login/user change, refreshing verification status");
            this.fetchVerificationStatus();
        }
        // If user just logged in while on session-expired, redirect back to intended page
        try {
            if (window.location.pathname === '/session-expired') {
                const tok = localStorage.getItem('studyapp.com');
                const expMs = parseJwtExpMs(tok);
                if (tok && expMs && expMs > Date.now()) {
                    const qs = new URLSearchParams(window.location.search);
                    const qpReturnTo = qs.get('returnTo');
                    const storedReturnTo = localStorage.getItem('returnTo');
                    const target = qpReturnTo || storedReturnTo || '/';
                    localStorage.removeItem('sessionExpiredNotified');
                    if (storedReturnTo) localStorage.removeItem('returnTo');
                    window.location.replace(target);
                }
            }
        } catch (_) { /* ignore */ }
        // Auto-select the newest child whenever childrenList prop grows
        if (
            prevProps.childrenList !== this.props.childrenList &&
            Array.isArray(this.props.childrenList) &&
            this.props.childrenList.length > 0
        ) {
            const latestChild = this.props.childrenList[this.props.childrenList.length - 1];
            this.handleSelectStudent(latestChild);
        }
    }

    render() {
        // Subscription display — read from the per-course subscriptions array.
        const activeCourseId = getActiveCourseId();
        const sub = getStoredSubscriptionForCourse(activeCourseId) || getStoredSubscriptions()[0] || null;
        const subscriptionStatus = sub?.status || null;
        const subscriptionPlanId = sub?.planKey || null;
        const subscriptionPlan = getBillingPlan(subscriptionPlanId) || getBillingPlan(resolvePlanId(subscriptionPlanId));
        const subscriptionEndDate = sub?.endDate ? new Date(sub.endDate) : null;
        const subscriptionCancelAtPeriodEnd = sub?.cancelAtPeriodEnd === true;
        const isNonRenewing = (subscriptionStatus || '').toLowerCase() === 'non_renewing';
        const isFixedTermPlan = subscriptionPlan?.autoRenews === false;
        const subscriptionDateLabel = getPlanDateLabel({
            status: subscriptionStatus,
            planId: subscriptionPlanId,
            cancelAtPeriodEnd: subscriptionCancelAtPeriodEnd
        });

        // When a parent subscribes during the trial, Chargebee keeps status='trialing'
        // until the trial ends. Use the paymentCommitted flag to show accurate text.
        const paymentCommitted = sub?.paymentCommitted === true;
        const isTrialingWithPayment = subscriptionStatus === 'trialing' && paymentCommitted;
        const displayStatus = isTrialingWithPayment ? 'subscribed (trial active)' : subscriptionStatus;
        const displayDateLabel = isTrialingWithPayment ? 'Subscription starts:' : subscriptionDateLabel;

        // Banner logic: prefer state (fresh from server), fallback to props, then localStorage
        const tokenPresent = !!localStorage.getItem('studyapp.com');
        const role = (typeof this.state.userRole !== 'undefined') ? this.state.userRole : (this.props.user?.role || localStorage.getItem('studyapp_role'));
        const isVerified = (typeof this.state.userIsVerified !== 'undefined') ? this.state.userIsVerified : (typeof this.props.user?.isVerified !== 'undefined' ? this.props.user.isVerified : (localStorage.getItem('user_isVerified') === 'true'));
        const isParentUnverified = tokenPresent && role === 'parent' && isVerified === false;
        // The brand doubles as the "home" link: signed-out visitors get the landing
        // page, signed-in users get the home their role actually belongs on.
        const brandTarget = tokenPresent ? getRoleHomePath(role) : '/';
        return (
            <React.Fragment>
                <Navbar light expand="md" fixed="top" container={false} className="shadow-sm" style={{ backgroundColor: 'var(--bg-page)' }}>
                    {/* Keep the fixed header independent from page-level .container rules,
                        and keep status banners out of the same flex row as the menu. */}
                    <div className="tc-navbar-shell">
                    <div className="tc-navbar-main">
                        <NavbarToggler onClick={this.toggleNav} />
                        {/* tag={Link} keeps this client-side — an href here reloaded the whole SPA. */}
                        <NavbarBrand tag={Link} to={brandTarget} className="tc-navbar-brand">
                            {/* Mark is decorative: the accessible name must stay "TestCoachAI"
                                because the E2E home-link tests locate this by role+name. */}
                            <img
                                className="tc-navbar-brand__mark"
                                src={`${process.env.PUBLIC_URL}/logo-icon.svg`}
                                alt=""
                                aria-hidden="true"
                            />
                            <span>TestCoach<span className="tc-navbar-brand__ai">AI</span></span>
                        </NavbarBrand>
                        <Collapse isOpen={this.state.isNavOpen} navbar>
                            <Nav className="tc-navbar-primary" navbar>
                                {/* commented for the time being and can uncomment later when we expand the app
                                {/* <NavItem>
                                    <NavLink className="nav-link" to="/dailylog">
                                        <span className="fa fa-home fa-lg"></span> Daily Log
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className="nav-link" to="/dashboard">
                                        <span className="fa fa-info fa-lg"></span> Dashboard
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className="nav-link" to="/timetable">
                                        <span className="fa fa-info fa-lg"></span> Timetable
                                    </NavLink>
                                </NavItem> */}

                                {this.props.user?.role === "student" && (
                                    <NavItem>
                                        <NavLink className="nav-link" to="/TakeTests">
                                            <span className="fa fa-book fa-lg"></span> Take Tests
                                        </NavLink>
                                    </NavItem>
                                )}

                                {(this.props.user?.role === "student" || this.props.user?.role === "parent" || this.props.user?.role === "teacher") && (
                                    <NavItem>
                                        <NavLink className="nav-link" to="/results">
                                            <span className="fa fa-book fa-lg"></span> Test Results{' '}
                                            {this.state.selectedStudentName !== 'My Students' && (
                                                <>for <span className="text-primary">{this.state.selectedStudentName}</span></>
                                            )}
                                        </NavLink>
                                    </NavItem>
                                )}

                                {/* {(this.props.user?.role === "parent" || this.props.user?.role === "teacher") && (
                                    <NavItem>
                                        <NavLink className="nav-link" to="/TakeTests">
                                            <span className="fa fa-book fa-lg"></span> Student Dashboard for {this.state.selectedStudentName}
                                        </NavLink>
                                    </NavItem>
                                )} */}

                                {(this.props.user?.role === "parent" || this.props.user?.role === "teacher") && (
                                    <NavItem>
                                        <NavLink className="nav-link" to="/parent-dashboard">
                                            <span className="fa fa-book fa-lg"></span> Dashboard{' '}
                                            {this.state.selectedStudentName !== 'My Students' && (
                                                <>for <span className="text-success">{this.state.selectedStudentName}</span></>
                                            )}
                                        </NavLink>
                                    </NavItem>
                                )}

                                {this.props.user?.admin && (
                                    <NavItem>
                                        <NavLink className="nav-link" to="/QuestionManager">
                                            <span className="fa fa-book fa-lg"></span> Manage Questions
                                        </NavLink>
                                    </NavItem>
                                )}
                                {this.props.user?.admin && (
                                    <NavItem>
                                        <NavLink className="nav-link" to="/PromptManager">
                                            <span className="fa fa-book fa-lg"></span> Prompt Manager
                                        </NavLink>
                                    </NavItem>
                                )}
                                {this.props.user?.admin && (
                                    <NavItem>
                                        <NavLink className="nav-link" to="/WritingPromptManager">
                                            <span className="fa fa-pencil fa-lg"></span> Writing Prompts
                                        </NavLink>
                                    </NavItem>
                                )}
                                {this.props.user?.admin && (
                                    <NavItem>
                                        <NavLink className="nav-link" to="/QuestionAuthoringStudio">
                                            <span className="fa fa-book fa-lg"></span> Question Authoring Studio
                                        </NavLink>
                                    </NavItem>
                                )}
                                {this.props.user?.admin && (
                                    <NavItem>
                                        <NavLink className="nav-link" to="/PatternWizard">
                                            <span className="fa fa-book fa-lg"></span> Passage Pack Wizard
                                        </NavLink>
                                    </NavItem>
                                )}
                                {this.props.user?.admin && (
                                    <NavItem>
                                        <NavLink className="nav-link" to="/BatchQuestionUpload">
                                            <span className="fa fa-upload fa-lg"></span> Batch Upload
                                        </NavLink>
                                    </NavItem>
                                )}
                                {this.props.user?.admin && (
                                    <NavItem>
                                        <NavLink className="nav-link" to="/admin">
                                            <span className="fa fa-book fa-lg"></span> Admin Dashboard
                                        </NavLink>
                                    </NavItem>
                                )}
                                {/* customtestbuilder */}
                                {(this.props.user?.admin || this.props.user?.role === "parent" || this.props.user?.role === "teacher") && (
                                    <NavItem>
                                        <NavLink className="nav-link" to="/CustomTestBuilder">
                                            <span className="fa fa-book fa-lg"></span>{' '}
                                            {this.props.user?.role === "parent" ? 'Create Assigned Test' : 'Create Assigned Test'}
                                        </NavLink>
                                    </NavItem>
                                )}
                                {(this.props.user?.admin || this.props.user?.role === "parent" || this.props.user?.role === "teacher") && (
                                    <NavItem>
                                        <NavLink className="nav-link" to="/remediation-dashboard">
                                            <span className="fa fa-line-chart fa-lg"></span> Assign Practice
                                        </NavLink>
                                    </NavItem>
                                )}

                                {/* NEW: If user is a parent, display a "My Students" dropdown. 7.06.25 commented until we support multiple students per parent */}
                                {/* {this.props.isLoggedIn && (this.props.user?.role === "parent" || this.props.user?.role === "teacher") && this.props.childrenList && this.props.childrenList.length > 0 && (
                                    <Dropdown nav isOpen={this.state.dropdownOpen} toggle={() => this.setState({ dropdownOpen: !this.state.dropdownOpen })}>
                                        <DropdownToggle nav caret>
                                            {this.state.selectedStudentName}
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            {this.props.childrenList.map(child => (
                                                <DropdownItem
                                                    key={child._id}
                                                    tag={NavLink}
                                                    to="/parent-dashboard"
                                                    onClick={() => this.handleSelectStudent(child)}
                                                >
                                                    {child.firstname} {child.lastname}
                                                </DropdownItem>
                                            ))}
                                        </DropdownMenu>
                                    </Dropdown>
                                )} */}
                            </Nav>
                            <Nav className="tc-navbar-actions" navbar>
                                {/* Shown to everyone, signed in or not, so a way to reach us is on every page (STUD-533). */}
                                <NavItem>
                                    <a className="nav-link" href={SUPPORT_MAILTO} title={SUPPORT_EMAIL}>
                                        <span className="fa fa-envelope fa-lg" aria-hidden="true"></span> Contact us
                                    </a>
                                </NavItem>
                                {/* Add Student button for parents if no selected student in localStorage */}
                                {this.props.isLoggedIn && this.props.user?.role === "parent" &&
                                    !localStorage.getItem('selectedStudent_name') && (
                                        <NavItem>
                                            <TcButton
                                                variant="primary"
                                                onClick={() => window.location.href = '/add-student'}
                                            >
                                                <span className="fa fa-user-plus fa-lg"></span> Add Student
                                            </TcButton>
                                        </NavItem>
                                    )}
                                {/* Feedback button for parents only */}
                                {this.props.isLoggedIn && this.props.user?.role === "parent" && (
                                    <NavItem>
                                        <TcButton
                                            variant="secondary"
                                            onClick={() => {
                                                const userID = encodeURIComponent(this.props.user?.userID || "");
                                                const feedbackUrl = `https://docs.google.com/forms/d/e/1FAIpQLScc6avHsVgsq2hkDEl_eDoacUb63NZhdDdXnHUfw48ZyRyB_w/viewform?usp=pp_url&entry.1725034985=${userID}`;
                                                window.open(feedbackUrl, "_blank");
                                            }}
                                        >
                                            <span className="fa fa-comment-alt"></span> Feedback
                                        </TcButton>
                                    </NavItem>
                                )}
                                {/* Display logout button if user is logged in */}
                                {this.props.isLoggedIn && (
                                    <NavItem>
                                        <Dropdown nav isOpen={this.state.profileDropdownOpen} toggle={this.toggleProfileDropdown}>
                                            <DropdownToggle
                                                nav
                                                style={{
                                                    width: '40px',
                                                    height: '40px',
                                                    borderRadius: 'var(--radius-circle)',
                                                    backgroundColor: 'var(--color-primary)',
                                                    color: 'var(--text-inverse)',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                {this.props.user?.firstname ? this.props.user.firstname.substring(0, 2).toUpperCase() : ''}
                                            </DropdownToggle>
                                            <DropdownMenu right className="custom-dropdown-menu">
                                                {/* Subscription cancellation banner */}
                                                {(subscriptionCancelAtPeriodEnd || isNonRenewing) &&
                                                    subscriptionEndDate && (
                                                        <div style={{
                                                            backgroundColor: 'var(--color-warning-muted)',
                                                            color: 'var(--text-warning)',
                                                            border: '1px solid var(--border-warning)',
                                                            borderRadius: 'var(--radius-sm)',
                                                            padding: '8px 12px',
                                                            marginBottom: '8px',
                                                            fontWeight: 600,
                                                            textAlign: 'center'
                                                        }}>
                                                            Your access will end on {new Date(subscriptionEndDate).toLocaleDateString('en-AU')}. You will have access until this date.
                                                        </div>
                                                    )}
                                                <DropdownItem header>{this.props.user?.firstname}</DropdownItem>

                                                {/* NEW: Subscription section (hide for students) */}
                                                {this.props.user?.role !== 'student' && (
                                                    <>
                                                        <DropdownItem header>Subscription</DropdownItem>
                                                        {subscriptionStatus ? (
                                                            <>
                                                                {subscriptionPlan && (
                                                                    <DropdownItem disabled>
                                                                        <strong>Plan:</strong> {subscriptionPlan.name}
                                                                    </DropdownItem>
                                                                )}
                                                                <DropdownItem disabled>
                                                                    <strong>Status:</strong> {displayStatus}
                                                                </DropdownItem>
                                                                {sub?.startDate && (
                                                                    <DropdownItem disabled>
                                                                        <strong>Start:</strong> {new Date(sub.startDate).toLocaleDateString('en-AU')}
                                                                    </DropdownItem>
                                                                )}
                                                                {subscriptionEndDate && (
                                                                    <DropdownItem disabled>
                                                                        <strong>{displayDateLabel}</strong>{' '}
                                                                        {new Date(subscriptionEndDate).toLocaleDateString('en-AU')}
                                                                    </DropdownItem>
                                                                )}
                                                                {(subscriptionCancelAtPeriodEnd || isNonRenewing) && subscriptionEndDate && !isFixedTermPlan ? (
                                                                    <DropdownItem onClick={() => window.location.href = `/checkout?plan=${encodeURIComponent(subscriptionPlanId || '')}&courseId=${activeCourseId}`}>
                                                                        Re-subscribe
                                                                    </DropdownItem>
                                                                ) : (
                                                                    subscriptionStatus === 'active' && !isFixedTermPlan && (
                                                                        <DropdownItem onClick={this.handleCancelSubscription} className="text-danger">
                                                                            Cancel subscription
                                                                        </DropdownItem>
                                                                    )
                                                                )}
                                                                {/* Insert Subscribe if in trialing status */}
                                                                {/* {subscriptionStatus === 'trialing' && (
                                                                    <DropdownItem onClick={() => window.location.href = '/checkout'}>
                                                                        Subscribe
                                                                    </DropdownItem>
                                                                )} */}
                                                                <DropdownItem divider />
                                                            </>
                                                        ) : (
                                                            <DropdownItem disabled>No subscription found</DropdownItem>
                                                        )}
                                                    </>
                                                )}

                                                {/* Existing Change Password and Logout */}
                                                {this.props.user?.role !== 'student' && (
                                                    <>
                                                        <DropdownItem onClick={this.toggleChangePasswordModal}>Change Password</DropdownItem>
                                                        {this.props.user?.role === 'parent' && (
                                                            <DropdownItem onClick={this.toggleResetChildPasswordModal}>Reset Child Password</DropdownItem>
                                                        )}
                                                    </>
                                                )}
                                                <DropdownItem onClick={this.logout}>Logout</DropdownItem>
                                            </DropdownMenu>
                                        </Dropdown>
                                    </NavItem>
                                )}
                                {/* Display login button if user is not logged in and no JWT token is present */}
                                {(!this.props.isLoggedIn && !localStorage.getItem('studyapp.com')) && (
                                    <>
                                        <NavItem>
                                            <NavLink className="nav-link" to="/login">
                                                <TcButton variant="primary">
                                                    <span className="fa fa-sign-in fa-lg"></span> Parent Login
                                                </TcButton>
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink className="nav-link" to="/student-login">
                                                <TcButton variant="secondary">
                                                    <span className="fa fa-user-graduate fa-lg"></span> Student Login
                                                </TcButton>
                                            </NavLink>
                                        </NavItem>
                                    </>
                                )}
                            </Nav>
                        </Collapse>
                    </div>
                        {/* Session banners below the menu (full width) */}
                        {this.props.isLoggedIn
                          && this.props.sessionRemainingMs != null
                          && this.props.sessionRemainingMs > 0
                          && this.props.sessionRemainingMs <= (7 * 24 * 60 * 60 * 1000) // show only in last 7 days
                          && (
                            <div
                                className="w-100 text-center"
                                role="status"
                                aria-live="polite"
                                title={`Your login session will expire in ${this.formatDuration(this.props.sessionRemainingMs)}. This is not related to your paid subscription. You will need to log in again to continue.`}
                                style={{
                                    backgroundColor: 'var(--color-primary-muted)',
                                    color: 'var(--color-primary)',
                                    border: '1px solid var(--border-primary)',
                                    borderRadius: 2,
                                    padding: '2px 8px',
                                    fontWeight: 600,
                                    fontSize: '0.8rem',
                                    lineHeight: 1.1,
                                    marginTop: 2,
                                    marginBottom: 0,
                                }}
                            >
                                🔐 <span style={{fontWeight: 700}}>Login session</span>: {this.formatDuration(this.props.sessionRemainingMs)}
                                <button
                                    type="button"
                                    onClick={this.toggleSessionInfoModal}
                                    aria-label="What does login session mean?"
                                    style={{
                                        border: 'none',
                                        background: 'transparent',
                                        cursor: 'pointer',
                                        fontSize: '0.8rem',
                                        textDecoration: 'underline',
                                        marginLeft: 8
                                    }}
                                >
                                    What’s this?
                                </button>
                            </div>
                        )}

                        {this.props.isLoggedIn && this.props.sessionRemainingMs != null && this.props.sessionRemainingMs <= 0 && (
                            <div
                                className="w-100 text-center"
                                role="status"
                                aria-live="polite"
                                title="Your login session has expired. This does not affect your paid subscription. Please log in again to continue."
                                style={{
                                    backgroundColor: 'var(--color-danger-muted)',
                                    color: 'var(--color-danger)',
                                    border: '1px solid var(--border-danger)',
                                    borderRadius: 2,
                                    padding: '2px 8px',
                                    fontWeight: 700,
                                    fontSize: '0.8rem',
                                    lineHeight: 1.1,
                                    marginTop: 2,
                                    marginBottom: 0,
                                }}
                            >
                                🔐 Session expired — please log in again
                            </div>
                        )}
                        {isParentUnverified && (
                            <div className="alert alert-warning text-center mb-0 py-1 px-2 w-100" style={{
                                borderRadius: 0,
                                fontSize: '0.9rem'
                            }}>
                                <strong>Verify your email</strong> to receive progress reports and updates.
                                <TcButton
                                    variant="secondary"
                                    size="sm"
                                    onClick={this.resendVerification}
                                    disabled={this.state.resendingVerify}
                                    style={{ marginLeft: 'var(--space-2)' }}
                                >
                                    {this.state.resendingVerify ? 'Sending…' : 'Resend link'}
                                </TcButton>
                                {this.state.resendMsg && (
                                    <span className="ms-2" style={{ fontSize: '0.95rem' }}>{this.state.resendMsg}</span>
                                )}
                            </div>
                        )}
                        <TrialBanner isLoggedIn={this.props.isLoggedIn} />
                    </div>
                </Navbar>
                <Modal isOpen={this.state.isChangePasswordModalOpen} toggle={this.toggleChangePasswordModal}>
                    <ModalHeader toggle={this.toggleChangePasswordModal}>Change Password</ModalHeader>
                    <ModalBody>
                        <Form onSubmit={(event) => this.handleChangePassword(event)}>
                            <FormGroup>
                                <Label htmlFor="oldPassword">Old Password</Label>
                                <Input type="password" id="oldPassword" name="oldPassword"
                                    innerRef={(input) => this.oldPassword = input} />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="newPassword">New Password</Label>
                                <Input type="password" id="newPassword" name="newPassword"
                                    innerRef={(input) => this.newPassword = input} />
                            </FormGroup>
                            <TcButton type="submit" variant="primary">Submit</TcButton>
                        </Form>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.isResetChildPasswordModalOpen} toggle={this.toggleResetChildPasswordModal}>
                    <ModalHeader toggle={this.toggleResetChildPasswordModal}>Reset Child Password</ModalHeader>
                    <ModalBody>
                        <Form onSubmit={this.handleResetChildPassword}>
                            <div className="alert alert-info" style={{ fontSize: '0.98rem', marginBottom: '1rem' }}>
                                <strong>Password requirements (student):</strong>
                                <ul style={{ marginBottom: 0 }}>
                                    <li>At least 8 characters</li>
                                    <li>Include at least one letter (A–Z or a–z)</li>
                                    <li>Include at least one number (0–9)</li>
                                </ul>
                            </div>
                            <FormGroup>
                                <Label htmlFor="childNewPassword">New Password for Child</Label>
                                <Input type="password" id="childNewPassword" name="childNewPassword"
                                    innerRef={(input) => this.childNewPassword = input} />
                            </FormGroup>
                            <TcButton type="submit" variant="primary">Submit</TcButton>
                        </Form>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.isSessionInfoOpen} toggle={this.toggleSessionInfoModal}>
                    <ModalHeader toggle={this.toggleSessionInfoModal}>About your login session</ModalHeader>
                    <ModalBody style={{ color: 'var(--text-primary)', opacity: 1 }}>
                        <p style={{marginBottom: '0.75rem'}}>The timer in the header is for your <strong>login session</strong> only. When it reaches zero, you’ll be securely logged out and asked to log in again.</p>
                        <ul style={{marginBottom: '0.75rem', color: 'var(--text-primary)' }}>
                            <li><strong>Session</strong> = security timer for your current sign‑in.</li>
                            <li><strong>Subscription</strong> = your paid access; separate from the session timer.</li>
                        </ul>
                        <p style={{marginBottom: 0}}>Your subscription status and renewal/end date appear in the profile menu. The blue banner here does <em>not</em> indicate subscription expiry.</p>
                    </ModalBody>
                </Modal>
            </React.Fragment>
        );
    }
}
export default connect(null, mapDispatchToProps)(Header);
